import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { PropTypes } from "prop-types";
import imgLogo from "../../../../../image/logo.png";
import api from "../../../../../utils/apidsf";
import swal from "sweetalert";
import { ReactSearchAutocomplete } from "react-search-autocomplete";
// import RichTextEditor from "react-rte";
import { RichTextEditor } from "@mantine/rte";

import "./CreateArticle.css";

// components
import FormField from "../../../Components/FormField/FormField";

export default function CreateArticle() {
  const params = useParams();
  const navigate = useNavigate();
  //const [id, setId] = useState("");

  const [allData, setAllData] = useState([]);
  const [chapterArray, setChapterArray] = useState([]);
  const [sectionArray, setSectionArray] = useState([]);
  const [sectionShow, setsectionshow] = useState(true);
  const [stateData, setSatateData] = useState([
    "Select State",
    "Andhra Pradesh State Laws",
    "Arunachal Pradesh State Laws",
    "Assam State Laws",
    "Bihar State Laws",
    "Chandigarh Local Acts",
    "Chhattisgarh State Laws",
    "Delhi Local Laws",
    "Goa State Laws",
    "Gujarat State Laws",
    "Haryana State Laws",
    "Himachal Pradesh State Laws",
    "Jammu and Kashmir State Laws",
    "Jharkhand State Laws",
    "Karnataka State Laws",
    "Kerala State Laws",
    "Madhya Pradesh State Laws",
    "Maharashtra State Laws",
    "Manipur State Laws",
    "Mizoram State Laws",
    "Nagaland State Laws",
    "Odisha State Laws",
    "Puducherry State Laws",
    "Punjab State Laws",
    "Rajasthan State Laws",
    "Sikkim State Laws",
    "Tamil Nadu State Laws",
    "Telangana State Laws",
    "Tripura State Laws",
    "UP State Laws",
    "Uttarakhand State Laws",
    "West Bengal State Laws",
  ]);
  const [bareactCategory, setBareActCategory] = useState([
    "Select Category",
    "Alternative Dispute Resolution Laws",
    "Armed Forces Laws",
    "Banking Laws",
    "Bills in Parliament",
    "Children Laws",
    "Civil Laws",
    "Consumer Protection Laws",
    "Corporate Laws",
    "Criminal Laws",
    "Direct Tax Laws",
    "Education Laws",
    "Environmental Laws",
    "Family Laws",
    "Food & Agriculture Laws",
    "Foreign Exchange Laws",
    "Human Rights Laws",
    "Indirect Tax Laws",
    "Information Technology Laws",
    "Insurance Laws",
    "Intellectual Property Laws",
    "International Laws and Conventions",
    "Legal and Professional Laws",
    "Media and Entertainment Law",
    "Medical and Health Laws",
    "Miscellaneous Laws",
    "Petroleum & Natural Gas Laws",
    "Political and Election Laws",
    "Power Sector Laws",
    "Property Laws",
    "Public Related Laws",
    "Railway Laws",
    "Repealed Laws",
    "Service and Labour Laws",
    "Tourism Laws",
    "Transport Laws",
  ]);
  const [formData, setFormData] = useState({
    title: "",
    category: "state",
    description: "",
    footnote: "",
    chapter_no: "",
    chapter_name: "",
    section_no: "",
    state: "",
    section_name: "",
    law_category: "",
  });

  const handleInputChange = (e) => {
    setFormData((prevState) => {
      return {
        ...prevState,
        [e.target.name]: e.target.value,
      };
    });
    setsectionshow(true);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    let id = params.id;
    let token = JSON.parse(localStorage.getItem("token"));
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: token,
      },
    };
    const createOrUpdateLandmark = async () => {
      try {
        let res = null;
        if (id) {
          res = await api.put(`/bare-act-admin/${id}`, formData, config);
        } else {
          res = await api.post("/bare-act-admin/", formData, config);
        }
        const data = res.data.data;
        setFormData({
          ...formData,
          description: "",
          footnote: "",
          section_no: "",
          section_name: "",
        });
        if (id) {
          navigate("/admin/bareAct-table");
        }
      } catch (err) {
        console.error(err.response.data.error);
        swal({
          title: "Error",
          text: err.response.data.error,
          icon: "error",
        });
      }
    };

    try {
      const actArr = await api.get(
        `/bare-act-admin/?title=${formData.title}&section_no=${section_no}&chapter_no=${chapter_no}`,
        config
      );
      if (id) {
        createOrUpdateLandmark();
        swal({
          title: "Bare Act Updated",
          text: "Bare Act Updated Successfully!!",
          icon: "success",
        });
      } else {
        if (actArr?.data?.data?.length > 0) {
          // act already exists
          swal({
            title: "Duplicate",
            text: "Bare Act Already Exists!!",
            icon: "warning",
          });
        } else {
          // create act
          createOrUpdateLandmark();
          swal({
            title: "Bare Act Added",
            text: "Bare Act Added Successfully!!",
            icon: "success",
          });
        }
      }
    } catch (err) {
      // swal({
      //   title: "Error",
      //   text: err,
      //   icon: "error",
      // })
      console.log(err);
    }

    // let tileFilter = allData?.filter(
    //   (w) =>
    //     w.title == formData.title &&
    //     w.chapter_no == formData.chapter_no &&
    //     w.section_no == formData.section_no
    // )
    // console.log({ tileFilter })
    // if (tileFilter?.length > 0) {
    //   try {
    //     swal({
    //       title: "Duplicate",
    //       text: "Bare Act Already Exists!!",
    //       icon: "warning",
    //     })
    //   } catch (err) {
    //     console.error(err.response.data.error)
    //     swal({
    //       title: "Error",
    //       text: err.response.data.error,
    //       icon: "error",
    //     })
    //   }
    // } else {
    //   createOrUpdateLandmark()
    //   swal({
    //     title: "Bare Act Added",
    //     text: "Bare Act Added Successfully!!",
    //     icon: "success",
    //   })
    // }
  };

  useEffect(() => {
    let id = params.id;
    let token = JSON.parse(localStorage.getItem("token"));

    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: token,
      },
    };

    const fetchLandmark = async () => {
      const res = await api.get(`/bare-act-admin/${id}`, config);
      const resDescription = await api.get(
        `/bare-act-admin/${id}?select=description`,
        config
      );
      const resFootnote = await api.get(
        `/bare-act-admin/${id}?select=footnote`,
        config
      );
      const { description } = resDescription.data.data;
      const { footnote } = resFootnote.data.data;
      const data = res.data.data;

      const {
        title,
        category,
        chapter_name,
        chapter_no,
        section_name,
        section_no,
        law_category,
        state,
      } = data;
      console.log(data);
      console.log(title);
      setFormData((prevState) => {
        return {
          ...prevState,
          title: title,
          category: category,
          chapter_no: chapter_no,
          chapter_name: chapter_name,
          section_no: section_no,
          section_name: section_name,
          law_category: law_category,
          state: state,
        };
      });
      setFormData((prevState) => {
        return {
          ...prevState,
          description,
        };
      });
      setFormData((prevState) => {
        return {
          ...prevState,
          footnote,
        };
      });
    };

    if (id) {
      fetchLandmark();
    } else {
      setFormData({
        ...formData,
        title: "",
        category: "state",
        description: "",
        footnote: "",
        chapter_no: "",
        chapter_name: "",
        section_no: "",
        state: "",
        section_name: "",
        law_category: "",
      });
    }
  }, [params]);

  useEffect(() => {
    // setDiscription();
    // setfootNote();
  }, []);
  useEffect(() => {
    // setfootNote();
  }, []);

  useEffect(async () => {
    let token = JSON.parse(localStorage.getItem("token"));

    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: token,
      },
    };
    try {
      const res = await api.get(`/bare-act-admin`, config);
      setAllData(res?.data?.data);
      console.log(res?.data?.data);
    } catch (error) {
      console.error(error);
    }
  }, []);

  useEffect(() => {
    let ArrayChapter = [];
    let ArraySection = [];
    for (let i = 0; i < 60; i++) {
      let value = { id: i + 1, name: i + 1, label: `Chapter ${i + 1}` };
      ArrayChapter.push(value);
    }

    for (let i = 0; i < 100; i++) {
      let value = { id: i + 1, name: i + 1, label: `Section ${i + 1}` };
      ArraySection.push(value);
    }

    setChapterArray(ArrayChapter);
    setSectionArray(ArraySection);
  }, []);

  const onChangeDiscription = (value) => {
    setFormData({
      ...formData,
      description: value,
    });
  };

  const onChangeFootnote = (value) => {
    setFormData({
      ...formData,
      footnote: value,
    });
  };

  const formatResult = (item) => {
    return (
      <>
        <span style={{ display: "block", textAlign: "left", zIndex: "999" }}>
          {item.name}
        </span>
      </>
    );
  };

  const {
    title,
    category,
    description,
    law_category,
    chapter_no,
    chapter_name,
    section_no,
    section_name,
    state,
    footnote,
  } = formData;
  return (
    <div style={{ flex: 4 }}>
      <form
        action=""
        className="admin__userUpdateForm"
        onSubmit={handleSubmit}
        onKeyPress={(e) => {
          e.key === "Enter" && e.preventDefault();
        }}
      >
        <div className="userUpdateLeft">
          <FormField
            type="text"
            label="Title"
            placeholder="Title"
            value={title}
            name="title"
            handleChange={handleInputChange}
          />

          <div className="userUpdateItem">
            <label className="user__label">Category</label>
            <select
              value={category}
              onChange={(e) => {
                setFormData({
                  ...formData,
                  category: e.target.value,
                });
              }}
            >
              <option value="state">State</option>
              <option value="center">Center</option>
            </select>
          </div>

          {category == "state" ? (
            <div className="userUpdateItem">
              <label className="user__label">State</label>
              <select
                value={state}
                onChange={(e) => {
                  setFormData({
                    ...formData,
                    state: e.target.value,
                  });
                }}
              >
                {stateData.map((w, i) => {
                  return (
                    <option value={w} key={i}>
                      {w}
                    </option>
                  );
                })}
              </select>
            </div>
          ) : (
            ""
          )}

          <div className="userUpdateItem">
            <label className="user__label"> Law Category</label>
            <select
              value={law_category}
              onChange={(e) => {
                setFormData({
                  ...formData,
                  law_category: e.target.value,
                });
              }}
            >
              {bareactCategory.map((w, i) => {
                return (
                  <option value={w} key={i}>
                    {w}
                  </option>
                );
              })}
            </select>
          </div>

          {/* <div className="userUpdateItem">
            <label className="user__label">Chapter </label>
            <Autocomplete
              id="free-solo-demo"
              options={chapterArray}
              // value={}
              getOptionLabel={(option) => option.label}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label={`Chapter ${chapter_no ? chapter_no : ""}`}
                  />
                  )}
                  onChange={(event, item) => {
                    console.log(item);
                    setFormData({
                  ...formData,
                  chapter_no: item.name,
                });
              }}
              />
            </div> */}

          <FormField
            type="text"
            label="Chapter / Part / Schedule / Appendix - Number"
            placeholder="Chapter-10B | Part-1B - please use hyphens for chapter number / part number ..."
            value={chapter_no}
            name="chapter_no"
            handleChange={handleInputChange}
          />
          <FormField
            type="text"
            label="Chapter / Part - Name"
            placeholder="Chapter / Part - Name"
            value={chapter_name}
            name="chapter_name"
            handleChange={handleInputChange}
          />

          {/* <div className="userUpdateItem">
            <label className="user__label">Section </label>
            
            <Autocomplete
            id="free-solo-demo"
            options={sectionArray}
            getOptionLabel={(option) => option.label}
              renderInput={(params) => (
                <TextField
                {...params}
                label={`Section ${section_no ? section_no : ""}`}
                />
                )}
                onChange={(event, item) => {
                  console.log(item);
                  setFormData({
                    ...formData,
                    section_no: item.name,
                  });
              }}
              />
            </div> */}

          <FormField
            type="text"
            label="Section / Article - Number"
            placeholder="Section-10B | Article-1B - please use hyphens for section number / article number ..."
            value={section_no}
            name="section_no"
            handleChange={handleInputChange}
          />

          <FormField
            type="text"
            label="Section / Article -   Name"
            placeholder="Section Name / Article Name"
            value={section_name}
            name="section_name"
            handleChange={handleInputChange}
          />

          <div className="userUpdateItem">
            <label className="user__label">Description</label>

            <RichTextEditor
              className="desc_area height_xl"
              value={description}
              onChange={onChangeDiscription}
            />
          </div>
          <div className="userUpdateItem">
            <label className="user__label">Footnote</label>

            <RichTextEditor
              className="desc_area "
              value={footnote}
              onChange={onChangeFootnote}
            />
          </div>

          <div>
            <button className="userUpdateButton" type="submit">
              {params.id ? "Update Bare Act" : "Add Bare Act"}
            </button>
          </div>
        </div>
      </form>
    </div>
  );
}
